import { VariantProps, cva } from "class-variance-authority";

const chipCva = cva(
  ["h-6 px-1.5 py-1 rounded text-xs font-bold leading-none"],
  {
    variants: {
      variant: {
        success: ["bg-green-100 text-gray-600"],
        warning: ["bg-yellow-100 text-yellow-600"],
        danger: ["bg-red-100 text-red-600"],
        info: ["bg-gray-100 text-gray-600"],
      },
    },
    defaultVariants: {
      variant: "success",
    },
  },
);

type ChipCVA = VariantProps<typeof chipCva>;

type ChipProps = {
  label: string;
} & ChipCVA;

function Chip({ label, variant }: ChipProps) {
  const chipClassName = chipCva({ variant });

  return <span className={chipClassName}>{label}</span>;
}

export default Chip;
